import React from 'react';
import { store } from '../store';
import { evaluateConditions } from '../common/utils/enrollment';

export function getPageScript({ script = [], section, page }) {
  let selectedPage = {};
  if (Array.isArray(script)) {
    script.forEach(s => {
      if (s.name === section && Array.isArray(s.pages)) {
        s.pages.forEach(p => {
          if (p.name === page) {
            selectedPage = p;
          }
        });
      }
    });
  }
  return selectedPage;
}

function parseScriptTags(text = '') {
  const output = [];

  const { tagsRegex } = store.getState().theme;
  let tagsRE = /\{\{[\w|,./'"?#$!–\-:()[\]& ]*\}\}/g; // default
  if (tagsRegex) {
    tagsRE = new RegExp(tagsRegex);
  }
  let i = 0;

  const matches = [...text.matchAll(tagsRE)];

  matches.forEach(m => {
    const tag = m[0]; // tag in the form of {{text|fmt-class1,fmt-class2}}
    const [ str, formattingStr ] = tag.slice(2, -2).split('|');

    const preTagText = text.slice(i, m.index);
    let el = '';

    if (formattingStr === 'break') {
      el = (<><br />&nbsp;</>);
    } else {
      const formatting = formattingStr ? formattingStr.split(',') : []; // now formatting is ['fmt-class1', 'fmt-class2']
      el = <span className={formatting.join(' ')}>{str}</span>;
    }
    output.push(preTagText);
    output.push(el);

    // set the index counter to the end of the tag so we can
    // parse the rest of the string
    i = m.index + tag.length;
  });
  output.push(text.slice(i));
  return output;
}

export function parseScriptTemplate(blocks = [], currentValues = {}) {
  const output = [];

  blocks.forEach(block => {
    const parsedText = parseScriptTags(block.text);
    const el = (
      <div className={block.indent ? 'mb-3 i1' : 'mb-3'}>
        {parsedText}
      </div>
    );

    // if display conditions are specified, check to see if they are met
    // before we display the block
    if (Array.isArray(block.displayIf) && block.displayIf.length) {
      const shouldDisplay = evaluateConditions({ conditions: block.displayIf, currentValues });
      if (shouldDisplay) output.push(el);

    // if there are no display conditions, just display the block
    } else {
      output.push(el);
    }
  });

  return output;
}

export function removeScriptOnlyRouting(formConfig = {}) {
  let updatedForm = formConfig.form.map(section => {
    if (section.scriptOnly) return undefined;
    return {
      ...section,
      pages: section.pages.filter(page => !page.scriptOnly),
    };
  });

  updatedForm = updatedForm.filter(section => section !== undefined);

  const updatedConfig = {
    ...formConfig,
    form: updatedForm,
  };
  return updatedConfig;
}
